import { useCallback, useEffect, useState } from "react";
import { checkLoginVk, checkLoginYoutube, startLoginVk, startLoginYoutube, useFetch, Platform, PLATFORM_VK } from "./api";

export const PLATFORM_TITLES: Record<Platform, string> = { vk: "ВК", youtube: "YouTube" };

/**
 * Whether the current session holds working credentials for a platform
 * (null while checking). Re-checks when the window regains focus, so logging
 * in from the tab opened by `login()` is picked up without a reload.
 */
export function usePlatformLogin(platform: Platform, enabled = true) {
  const { fetch } = useFetch();
  const [ok, setOk] = useState<boolean | null>(null);

  const check = useCallback(async () => {
    try { await (platform === PLATFORM_VK ? checkLoginVk({ fetch }) : checkLoginYoutube({ fetch })); setOk(true); }
    catch { setOk(false); }
  }, [fetch, platform]);

  useEffect(() => {
    if (!enabled) return;
    check();
    window.addEventListener("focus", check);
    return () => window.removeEventListener("focus", check);
  }, [check, enabled]);

  // A new tab keeps half-filled forms intact; the session cookie is shared.
  const login = useCallback(async () => {
    const { redirect_uri } = await (platform === PLATFORM_VK ? startLoginVk({ fetch }) : startLoginYoutube({ fetch }));
    window.open(redirect_uri, "_blank", "noopener");
  }, [fetch, platform]);

  return { ok, check, login };
}
